<div class="metric-progress-bar">
  <div class="current-target" *ngIf="currentTargetShare !== null" [style.left.%]="currentTargetShare"></div>
  <div class="total bar" [style.width.%]="totalShare"></div>
  <div class="target bar"></div>
</div>
